module.exports = __webpack_public_path__ + "static/media/icon-nopadding.7e375a12.png";